// Pages d'atterrissage Google Ads — Charente (16)
export const CHARENTE = {
  name: "Charente (16)",
  cities: [
    "Angoulême", "Cognac", "Soyaux", "Ruelle-sur-Touvre", "La Couronne",
    "Saint-Yrieix-sur-Charente", "Gond-Pontouvre", "Champniers", "L'Isle-d'Espagnac",
    "Jarnac", "Châteaubernard", "Nersac", "Fléac", "Magnac-sur-Touvre",
    "Ruffec", "Barbezieux-Saint-Hilaire", "Confolens", "La Rochefoucauld-en-Angoumois",
    "Châteauneuf-sur-Charente", "Roullet-Saint-Estèphe", "Mansle-les-Fontaines",
    "Chasseneuil-sur-Bonnieure", "Puymoyen", "Montbron", "Chabanais",
  ],
  mapEmbed: "https://www.google.com/maps?q=Charente%2C%20France&z=9&output=embed",
};

// Avis clients spécifiques Charente (16) — utilisés uniquement sur les pages Ads
export const CHARENTE_REVIEWS = {
  plomberie: [
    { name: "Sophie M.", city: "Angoulême", rating: 5, text: "Intervention très rapide pour une fuite d'eau. Plombier chez moi en moins d'une heure, propre et efficace." },
    { name: "Karim B.", city: "Cognac", rating: 5, text: "Chauffe-eau remplacé dans la journée. Prix annoncé respecté à l'euro près. Je recommande." },
    { name: "Nathalie D.", city: "Soyaux", rating: 5, text: "Artisan très professionnel, il a débouché ma canalisation en un temps record." },
    { name: "Thomas L.", city: "Ruelle-sur-Touvre", rating: 5, text: "Fuite sous l'évier réparée parfaitement. Explications claires, facture détaillée." },
    { name: "Awa S.", city: "Jarnac", rating: 5, text: "WC bouché un dimanche, réglé en 30 min. Merci pour la réactivité !" },
  ],
  serrurerie: [
    { name: "Julien P.", city: "Angoulême", rating: 5, text: "Porte ouverte en moins de 20 minutes, sans aucun dégât. Serrurier au top." },
    { name: "Claire V.", city: "La Couronne", rating: 5, text: "Serrurier très honnête, il m'a évité un changement de serrure inutile." },
    { name: "Mehdi R.", city: "Gond-Pontouvre", rating: 5, text: "Intervention de nuit impeccable après une porte claquée. Très rassurant." },
    { name: "Isabelle G.", city: "Cognac", rating: 5, text: "Blindage de porte posé nickel, travail soigné et conseils utiles." },
    { name: "Paul H.", city: "Barbezieux-Saint-Hilaire", rating: 5, text: "Changement de serrure multipoints rapide et propre. Parfait." },
  ],
  electricite: [
    { name: "Émilie R.", city: "Angoulême", rating: 5, text: "Panne électrique résolue rapidement un soir de semaine. Électricien très compétent." },
    { name: "David K.", city: "Cognac", rating: 5, text: "Tableau électrique remis aux normes, travail sérieux et propre." },
    { name: "Laura T.", city: "Confolens", rating: 5, text: "Excellent électricien, il a trouvé la panne que deux autres n'avaient pas vue." },
    { name: "Marc B.", city: "Châteaubernard", rating: 5, text: "Court-circuit réparé en urgence, diagnostic clair et rassurant." },
    { name: "Fatou N.", city: "Ruffec", rating: 5, text: "Installation de spots et éclairage nickel, très satisfaite du rendu." },
  ],
};

// metier -> config. category = clé partagée (BRANDS, REVIEWS, service formulaire)
export const ADS = {
  plomberie: {
    path: "/plombier-charente",
    category: "plomberie",
    icon: "Droplets",
    image: "/images/plomberie.jpg",
    metier: "Plombier",
    title: "Plombier Charente (16) — Dépannage 24/7 Angoulême, Cognac",
    metaDescription: "Plombier d'urgence en Charente (16) : Angoulême, Cognac et alentours. Fuite, débouchage, chauffe-eau. Intervention rapide 24h/24, devis gratuit. Appelez maintenant.",
    h1: "Plombier d'urgence",
    intro: "Fuite d'eau, canalisation bouchée, chauffe-eau en panne ? Nos plombiers interviennent rapidement à Angoulême, Cognac et dans toute la Charente, 24h/24 et 7j/7. Devis clair annoncé avant l'intervention.",
    points: [
      "Recherche et réparation de fuite",
      "Débouchage de canalisation & WC",
      "Dépannage et remplacement de chauffe-eau",
      "Fuite de robinet et robinetterie",
      "Dégât des eaux, mise en sécurité",
      "Intervention 24h/24 en Charente",
    ],
    faq: [
      { q: "Intervenez-vous à Angoulême et Cognac ?", a: "Oui, nous couvrons Angoulême, Cognac et l'ensemble du département de la Charente (16)." },
      { q: "Quel est le délai d'intervention en Charente ?", a: "Nous nous déplaçons dans les plus brefs délais ; le délai vous est confirmé lors de votre appel selon votre commune." },
      { q: "Le devis est-il gratuit ?", a: "Oui, le devis est gratuit et le tarif est validé avec vous avant toute intervention." },
      { q: "Êtes-vous disponibles la nuit et le week-end ?", a: "Oui, 24h/24 et 7j/7, y compris les jours fériés." },
    ],
  },
  serrurerie: {
    path: "/serrurier-charente",
    category: "serrurerie",
    icon: "KeyRound",
    image: "/images/serrurerie.jpg",
    metier: "Serrurier",
    title: "Serrurier Charente (16) — Ouverture de porte 24/7 Angoulême",
    metaDescription: "Serrurier d'urgence en Charente (16) : Angoulême, Cognac et alentours. Ouverture de porte sans dégât, changement de serrure, blindage. 24h/24, devis gratuit.",
    h1: "Serrurier d'urgence",
    intro: "Porte claquée, clé cassée ou effraction ? Nos serruriers ouvrent sans dégât dans la majorité des cas et sécurisent votre logement à Angoulême, Cognac et dans toute la Charente, à toute heure.",
    points: [
      "Ouverture de porte sans dégât",
      "Extraction de clé cassée",
      "Changement de cylindre et de serrure",
      "Serrure multipoints et verrou",
      "Blindage & sécurisation après effraction",
      "Intervention 24h/24 en Charente",
    ],
    faq: [
      { q: "Ouvrez-vous les portes sans les casser ?", a: "Dans la grande majorité des cas (porte claquée), nous ouvrons sans aucun dégât ni changement de serrure." },
      { q: "Intervenez-vous partout en Charente ?", a: "Oui, à Angoulême, Cognac et dans l'ensemble du département (16)." },
      { q: "Quels justificatifs demandez-vous ?", a: "Un justificatif de domicile vous est demandé avant toute ouverture, pour votre sécurité." },
      { q: "Disponibles la nuit ?", a: "Oui, notre service d'urgence fonctionne 24h/24 et 7j/7." },
    ],
  },
  electricite: {
    path: "/electricien-charente",
    category: "electricite",
    icon: "Zap",
    image: "/images/electricite.jpg",
    metier: "Électricien",
    title: "Électricien Charente (16) — Dépannage 24/7 Angoulême, Cognac",
    metaDescription: "Électricien d'urgence en Charente (16) : Angoulême, Cognac et alentours. Panne de courant, court-circuit, tableau, mise aux normes. 24h/24, devis gratuit.",
    h1: "Électricien d'urgence",
    intro: "Panne de courant, court-circuit, tableau qui disjoncte ? Nos électriciens certifiés diagnostiquent et sécurisent votre installation à Angoulême, Cognac et dans toute la Charente, de jour comme de nuit.",
    points: [
      "Panne de courant totale ou partielle",
      "Court-circuit et disjonction répétée",
      "Réparation de tableau électrique",
      "Mise aux normes NF C 15-100",
      "Remplacement prises & interrupteurs",
      "Intervention 24h/24 en Charente",
    ],
    faq: [
      { q: "Intervenez-vous à Angoulême et dans le 16 ?", a: "Oui, nous couvrons Angoulême, Cognac et tout le département de la Charente." },
      { q: "Vos électriciens sont-ils certifiés ?", a: "Oui, diplômés, assurés et intervenant dans le respect de la norme NF C 15-100." },
      { q: "Une odeur de brûlé, est-ce urgent ?", a: "Oui, coupez le courant si possible et appelez-nous immédiatement : risque d'incendie." },
      { q: "Disponibles 24/7 ?", a: "Oui, 24h/24, 7j/7, week-ends et jours fériés compris." },
    ],
  },
};
